export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-gradient-to-br from-primary-600 via-primary-500 to-accent-600 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-background-50/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-background-50/8 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50">
              随时随地 · 畅享影视大全
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed max-w-md mx-auto lg:mx-0">
              青青草视频移动端适配已全面优化，手机浏览器直接访问即可获得流畅的热门视频合集浏览体验。
              无需下载APP，打开浏览器就能畅享妖精视频、桃花视频、苹果视频、榴莲视频等全部平台资源。
            </p>
            <div className="flex items-center gap-4 mt-7 justify-center lg:justify-start flex-wrap">
              <button className="px-6 py-3 bg-background-50 text-primary-600 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer shadow-lg">
                <i className="ri-smartphone-line mr-2"></i>
                手机浏览器打开
              </button>
              <button className="px-6 py-3 bg-background-50/15 text-background-50 rounded-full text-sm font-semibold border border-background-50/30 hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-bookmark-line mr-2"></i>
                添加桌面快捷方式
              </button>
            </div>
            <div className="flex items-center gap-6 mt-6 justify-center lg:justify-start flex-wrap">
              <div className="flex items-center gap-2 text-background-300 text-xs">
                <i className="ri-checkbox-circle-line text-accent-300"></i>
                <span>无需下载安装</span>
              </div>
              <div className="flex items-center gap-2 text-background-300 text-xs">
                <i className="ri-checkbox-circle-line text-accent-300"></i>
                <span>即开即用浏览</span>
              </div>
              <div className="flex items-center gap-2 text-background-300 text-xs">
                <i className="ri-checkbox-circle-line text-accent-300"></i>
                <span>全平台资源覆盖</span>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="relative">
              <div className="w-56 md:w-64 aspect-[9/16] rounded-3xl overflow-hidden bg-background-800 border-4 border-background-50/20 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20entertainment%20app%20interface%20mockup%20on%20smartphone%2C%20warm%20ambient%20lighting%2C%20modern%20design%2C%20cinematic%20atmosphere%2C%20professional%20quality%2C%20elegant%20presentation%2C%20coral%20and%20amber%20tones&width=600&height=1067&seq=app-mockup-01&orientation=portrait"
                  alt="青青草视频移动端界面展示"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -top-4 -right-4 w-20 h-20 bg-accent-400/30 rounded-3xl -z-10"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-background-50/20 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}